// Version : 1.0.0
// Author : AGALYA

import VerifyOtpActionType from './verify-otp.types';

/** ***************** Otp Verify Mobile Number Start ************************/
export const verifyMemberNumberOtpStart = (otpCredentials: any) => ({
	type: VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_START,
	payload: otpCredentials,
});

export const verifyMemberNumberOtpSuccess = (otpSuccess: any) => ({
	type: VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_SUCCESS,
	payload: otpSuccess,
});

export const verifyMemberNumberOtpFailure = (otpFailure: any) => ({
	type: VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_FAILURE,
	payload: otpFailure,
});

export const verifyMemberNumberOtpResponseResetStart = () => ({
	type: VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_RESPONSE_REST_START,
});

export const verifyMemberNumberOtpUserResponseChanged = () => ({
	type: VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_RESPONSE_CHANGED,
});
/** ***************** Otp Verify Mobile Number End ************************/

/** ***************** Resend Otp Verify Mobile Number Start ************************/
export const reSendOtpStart = (otpCredentials: any) => ({
	type: VerifyOtpActionType.RE_SEND_OTP_START,
	payload: otpCredentials,
});

export const reSendOtpSuccess = (otpSuccess: any) => ({
	type: VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_SUCCESS,
	payload: otpSuccess,
});

export const reSendOtpFailure = (error: any) => ({
	type: VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_FAILURE,
	payload: error,
});

export const reSendOtpRestResponseStart = () => ({
	type: VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_RESET_START,
});

export const reSendOtpResponseChanged = () => ({
	type: VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_CHANGED,
});
/** *****************Resend  Otp Verify Mobile Number End ************************/
